<template>
  <div class="footer flex">
    <div class="box">
      Copyright @ 2020 朗朗书声 All Right Reserved <br /><a
        href="http://www.beian.miit.gov.cn"
        >京ICP备19040061号</a
      >
    </div>
    <div class="box">
      <a
        target="_blank"
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502040926"
        style="display: inline-block"
      >
        <img src="~images/icon-wj.png" style="float: left" />
        <p
          style="
            float: left;
            height: 20px;
            line-height: 20px;
            margin: 0px 0px 0px 5px;
          "
        >
          京公网安备 11010502040926号
        </p>
      </a>
    </div>
    <div class="box flex">
      <div class="item flex-v">
        <img class="code" src="~images/qrcode.jpg" alt="" />
        <p>朗朗书声小程序</p>
      </div>
      <div class="item flex-v">
        <img class="code" src="~images/qrcode1.jpg" alt="" />
        <p>朗朗书声公众号</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.footer {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 20px 200px;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: flex-end;

  .box {
    color: #666666;
    font-size: 12px;
    .item {
      align-items: center;
      font-size: 12px;
      color: #333333;
      margin-left: 43px;
      .code {
        width: 80px;
        height: 80px;
        margin-bottom: 8px;
      }
    }
  }
}
</style>
